module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    attrs: {
      "name": "hres80x-heal-illness1-detail"
    }
  }, [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.numseq))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": 'flgHeal' + _vm.numseq
    },
    domProps: {
      "checked": _vm.value === '0'
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": 'flgHeal' + _vm.numseq
    },
    domProps: {
      "checked": _vm.value === '1'
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.remark))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fa3708f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres80x/healIllness1Detail.vue
// module id = 4017
// module chunks = 1